import { render, staticRenderFns } from "./DialogRejectDepositRefund.vue?vue&type=template&id=23dc706c&scoped=true"
import script from "./DialogRejectDepositRefund.vue?vue&type=script&lang=js"
export * from "./DialogRejectDepositRefund.vue?vue&type=script&lang=js"
import style0 from "./DialogRejectDepositRefund.vue?vue&type=style&index=0&id=23dc706c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc706c",
  null
  
)

export default component.exports